import {
   Box
  ,Avatar
} from 'external/material'
import useCatalog from 'hooks/catalog'

export default function Teacher(props) {
  const [teacher = {}] = props.teachers || []
  const {subjects = {}} = useCatalog()
  const {color: bgcolor, textColor: color} = props.course
    ? subjects[props.course.substring(0, 2)] || {}
    : {}
  const {initials, name}  = teacher
  return (
  <Box className={props.className || "teacher"}>
     <Avatar sx={{ bgcolor, color}}>{initials}</Avatar>
     <Box className="teacherName" sx={{display: props.hideName ? 'none': undefined}} title={name}>{name}</Box>
  </Box>
  )
}
